import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { http } from "../../lib/api";

const AuthCtx = createContext(null);

let refreshing = null;
http.interceptors.response.use(undefined, async (err) => {
  const cfg = err?.config;
  if (err?.response?.status === 401 && cfg && !cfg._retry && !cfg.url?.includes("/auth/")) {
    cfg._retry = true;
    refreshing = refreshing || http.post("/auth/refresh").finally(() => { refreshing = null; });
    try { await refreshing; return http(cfg); } catch { /* fall through */ }
  }
  return Promise.reject(err);
});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const check = useCallback(async () => {
    try { const { data } = await http.get("/auth/me"); setUser(data); }
    catch {
      try { const { data } = await http.post("/auth/refresh"); setUser(data); }
      catch { setUser(false); }
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const logout = async () => { try { await http.post("/auth/logout"); } finally { setUser(false); } };
  return <AuthCtx.Provider value={{ user, setUser, logout }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
